export const ENDPOINTS = {
  USER: "/user",
  HEADERS: "/headers",
  OFFERS: "/offers",
  DASHBOARD: "/dashboard",
  AGENCY_USERS: "/agency-user",
  NOTIFICATION: "/notification",
  AUTH_LOGOUT: "/auth/logout",
  AUTH_SETUP_AUTHENTICATOR: "auth/setup-authenticator",
  AUTH_VERIFY_AUTHENTICATOR_SETUP: "auth/verify-authenticator-setup",
}

export default ENDPOINTS
